import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import logoutIcon from 'src/assets/logout.png';
import { i18nKey } from 'src/locales/i18n';
import MenuItem from './menu-item/menu-item';
import styles from './menu.module.less';
import useMenuItem from 'src/hooks/useMenuItem';
import { useNavigate } from 'react-router-dom';
import { IAuthStore } from 'src/store/auth/auth.store';
import useStore from 'src/hooks/useStore';
import { PAGE_ROUTE } from 'src/constants/route';
import { observer } from 'mobx-react-lite';
import { IUserStore } from 'src/store/user';
export interface IMenuProps {
	onItemClick?: () => void;
}
const Menu: FC<IMenuProps> = ({ onItemClick }) => {
	const [activeMenuId, setActiveMenuId] = useState('');

	const [t] = useTranslation();
	const navigator = useNavigate();

	const authStore: IAuthStore = useStore('authStore');
	const userStore: IUserStore = useStore('userStore');
	const menu = useMenuItem();
	const linkMenuList = menu.map((item) => item.id);

	const onItemClickInternal = (key: string) => {
		setActiveMenuId(key as PAGE_ROUTE);
		navigator(key);
		onItemClick && onItemClick();
	};

	const logout = async () => {
		userStore.updateDashboard(false);
		await authStore.logout();
		navigator(PAGE_ROUTE.LOGIN);
	};

	return (
		<>
			<div className={styles.menuContainer}>
				<div className={styles.titlePage}>
				</div>
				{menu.map((m) => {
					return (
						<MenuItem
							key={m.id}
							menuId={m.id}
							icon={m.icon}
							isActive={m.id === activeMenuId}
							onItemClick={onItemClickInternal}
							title={m.title}
							linkMenuList={linkMenuList}
						/>
					);
				})}
				<div className={styles.logoutIcon} onClick={logout}>
					<img src={logoutIcon} />
					<div>{t(i18nKey.dashboard.menu.logout)}</div>
				</div>
			</div>
		</>
	);
};

export default observer(Menu);
